import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "./data";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkCls = ({ isActive }) =>
    `text-[13px] font-medium tracking-[0.12em] uppercase pb-1 border-b transition-[color,border-color] duration-200 ${
      isActive
        ? "text-[#0D2B1E] border-[#BFA26F]"
        : "text-[#4A5D54] border-transparent hover:text-[#0D2B1E]"
    }`;

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#FBF9F6]/90 border-b border-[#0D2B1E]/10 transition-[box-shadow] duration-300 ${
        scrolled ? "shadow-[0_1px_0_rgba(191,162,111,0.4)]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <Link to="/" data-testid="navbar-logo-link" className="flex items-center">
          <img src="/rsc-logo.webp" alt="RSC Imports" className="h-10 md:h-11 w-auto" />
        </Link>
        <nav className="hidden lg:flex items-center gap-7" data-testid="navbar-desktop-links">
          {NAV_LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className={linkCls}>
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/partner"
            data-testid="nav-partner-cta"
            className="text-[13px] font-semibold tracking-[0.12em] uppercase px-6 py-2.5 bg-[#0D2B1E] text-[#FBF9F6] border border-[#0D2B1E] hover:bg-transparent hover:text-[#0D2B1E] transition-[background-color,color] duration-300"
          >
            Partner With Us
          </Link>
        </nav>
        <button
          data-testid="navbar-mobile-toggle"
          className="lg:hidden text-[#0D2B1E]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
      </div>
      {open && (
        <nav
          data-testid="navbar-mobile-menu"
          className="lg:hidden border-t border-[#0D2B1E]/10 bg-[#FBF9F6] px-6 py-6 flex flex-col gap-5"
        >
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setOpen(false)}
              className="text-sm font-medium tracking-[0.12em] uppercase text-[#0D2B1E]"
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/partner"
            data-testid="nav-mobile-partner-cta"
            onClick={() => setOpen(false)}
            className="text-[13px] font-semibold tracking-[0.12em] uppercase px-6 py-3 bg-[#0D2B1E] text-[#FBF9F6] text-center"
          >
            Partner With Us
          </Link>
        </nav>
      )}
    </header>
  );
};
